module.exports = __webpack_public_path__ + "components/country-flag/static/sr-7bc4ddd7b1dfad64ba1607db24072442.svg";